
// ==============================================

//        SLIDER SLICK

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {


var slider = $('#slider-posts');
var dotsManager;

// check if direct slide from hash url
var startSlide = 0;
var pattern    = 'slide';
var hash       = location.hash.substr(1);

if (hash && hash.startsWith(pattern)) {
  startSlide = Number(hash.substring(pattern.length))-1;
  // console.log(startSlide);
}

$(slider).on('init', function (event, slick) {
  // console.log('init', slick);
  setDotsManager(slick);
  $(slider).removeClass('is-closed');    // show only after init to prevent FOUC
});


// set and reset dots manager when init and breakpoint change
function setDotsManager(slick) {

  // console.log('\nsetDotsManager', window.innerWidth);

  //=====================================================================
  // usage (with "small-preview" is the id of div that is used for slick)
  //=====================================================================
  var winW                = window.innerWidth;
  var numberOfItems       = 6; // number of items on the slide
  var numberOfDotsVisible = 8; // number of dots visible

  if (winW > 1024) {
    numberOfItems       = 6;
    numberOfDotsVisible = 12;
  } else if (winW > 640 && winW < 1024) {
    numberOfItems       = 4;
    numberOfDotsVisible = 8;
  } else {
    numberOfItems       = 8;
    numberOfDotsVisible = 4;
  }
  dotsManager = new ClassDotsManager('slider-posts', numberOfItems, numberOfDotsVisible);
  dotsManager.init();
  dotsManager.updateDots(slick.currentSlide);
}

// setTimeout(function(){

//        Slider slick element
// ==============================================
if ($('.slider-posts__item').length  > 1) {
  $(slider).slick({
    slidesToShow  : 1,
    slidesToScroll: 1,
    slidesPerRow  : 3,
    rows          : 2,
    initialSlide  : startSlide,

    arrows        : true,
    dots          : true,
    appendDots    : '.slider-controls',
    appendArrows  : '.slider-controls',
    prevArrow     : '.slick-prev',
    nextArrow     : '.slick-next',

    lazyLoad      : 'ondemand',
    draggable     : true,
    infinite      : false,
    cssEase       : 'ease-in-out',
    speed         : 600,

    responsive: [
      // medium -> 2 columns, 4 thumbs
      {
        breakpoint: 1024,
        settings: {
          slidesPerRow: 2,
        }
      },
      // small -> 1 column, 2 thumbs
      {
        breakpoint: 640,
        settings: {
          slidesPerRow  : 1,
          rows          : 8,
          adaptiveHeight: true,
          fade          : true,
          speed         : 300,
        }
      },
    ]

  });
}

// ***
// }, 1);


//        Limit the number of dots visible in slick slider
// ==============================================

function ClassDotsManager(slickElementId, numOfItems, numOfDots) {
  this.listDotsElement = $("ul.slick-dots li");
  this.totalOfDots = this.listDotsElement.length;
  // this.listDotsElement = $("#" + slickElementId + " ul.slick-dots li");
  // this.numOfDots = numOfDots <= numOfItems ? numOfDots : numOfItems;
  this.numOfDots = numOfDots;
  this.minIndex = 0;
  this.maxIndex = numOfDots - 1;

  // console.log('  numOfDots (visible) / numOfItems (per slide) / totalOfDots', this.numOfDots, '/', numOfItems, '/', this.totalOfDots);
  // console.log('  minIndex / maxIndex', this.minIndex, '/', this.maxIndex);

  this.showDotsBetween = function (minIndex, maxIndex) {
    this.listDotsElement.filter(function (index) {
        $(this).css("display", index >= minIndex && index <= maxIndex ? "inline-block" : "none");
    });
  };
  this.init = function () {
    this.showDotsBetween(0, this.numOfDots - 1);
  };
  this.updateDots = function (newIndex) {
    // console.log('\nupdateDots', newIndex);
    if (newIndex >= this.minIndex && newIndex <= this.maxIndex) {
      // don't need to update
    } else {
      if (newIndex > this.maxIndex) {
        this.minIndex = newIndex;
        this.maxIndex = Math.min(this.minIndex + this.numOfDots - 1, this.totalOfDots-1);
        // this.maxIndex = newIndex;
        // this.minIndex = this.maxIndex - this.numOfDots + 1;
        // console.log('  -->', this.minIndex, this.maxIndex);
      } else {
        this.maxIndex = newIndex;
        this.minIndex = Math.max(this.maxIndex - this.numOfDots + 1, 0);
        // this.minIndex = newIndex;
        // this.maxIndex = this.minIndex + this.numOfDots - 1;
        // console.log('  <--', this.minIndex, this.maxIndex);
      }
      this.showDotsBetween(this.minIndex, this.maxIndex);
    }
  };
}


//        Events
// ==============================================

$(slider).on('beforeChange', function(event, slick, currentSlide, nextSlide){
  // console.log('beforeChange current / next : ', currentSlide, nextSlide);
  dotsManager.updateDots(nextSlide);

  // scroll to slider top on mobile
  if (window.innerWidth < 640) {
    $('body,html').animate({
      scrollTop : document.getElementById('slider-posts').offsetTop - 80
    }, 800, 'easeInOutCirc', function(){});
  }
});


/*
$('.slick-next').click(function(e) {

  // scroll to slider top on mobile
  // $('body,html').animate({
  //   scrollTop : document.getElementById('slider-posts').offsetTop
  // }, 1000, 'easeInOutCubic', function(){
  //   $(slider).slick('slickNext');
  // });

  // document.getElementById('slider-posts').scrollIntoView({behavior: "smooth"});
  // setTimeout(function() {
  //    $(slider).slick('slickNext');
  //  }, 1000);
});*/


// save current slide for navigation history when back
$(slider).on('afterChange', function (slick, currentSlide) {
  location.hash = 'slide'+(currentSlide.currentSlide+1);
});


// breakpoint change
$(slider).on('breakpoint', function (event, slick, breakpoint) {
  // console.log('on breakpoint', breakpoint);
  setDotsManager(slick);
});


// hash change in url
function locationHashChanged() {
  hash = location.hash.substr(1);

  if (hash && hash.startsWith(pattern)) {
    var hashSlide = Number(hash.substring(pattern.length))-1;
    // var sslider = $('#slider-posts').slick('getSlick');
    // console.log('listen hashchange', hashSlide, $('#slider-posts').slick('slickCurrentSlide'));
    if ($('#slider-posts').slick('slickCurrentSlide') != hashSlide) {
      $('#slider-posts').slick('slickGoTo', hashSlide);
    }
  }
}
window.addEventListener('hashchange', locationHashChanged, false);


})
